import React, { useState, useEffect, useRef } from 'react';
import Translations from '../../services/translation.service';
import PACIMob from "../../assets/img/PACIMob.svg";
import PaciSuccess from './paci-success.component';
import PaciFailure from './paci-failure.component';
import moment from "moment";
import PaciService from '../../services/paci_connection.service';
import Storage from '../../services/storage.service';
import User from '../../services/user.service';
import StorefrontTitle from '../shared/storefront-title.component';
import StmSummary from '../shared/storefront-summary';

const subscriptions = [];
const PaciConnection = (props) => {
    const [translationKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {})
    const [paciResponse, setPaciResponse] = useState(null);
    const [businessTime, setBusinessTime] = useState(0);
    const [timer, setTimer] = useState(null);
    const [pending, setPending] = useState(false);

    const timerRef = useRef();
    useEffect(() => {
        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        )

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }

    }, []);

    const updateTimer = () => {
        timerRef.current = setInterval(() => {
            setTimer((timer) => timer - 1);
        }, 1000);
    };

    const clearTimer = () => {
        clearInterval(timerRef.current);
        timerRef.current = null;
    }

    useEffect(() => {
        updateTimer();
        fetchTimerValue();
        checkPaciConnection();
        return () => {
            clearTimer();
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getTime = () => {
        let datM = moment.duration(timer, "seconds").minutes();
        let datS = moment.duration(timer, "seconds").seconds();
        datM = `${datM > 9 ? datM : `0${datM}`}`;
        datS = `${datS > 9 ? datS : `0${datS}`}`;
        return `${datM}:${datS}`;
    }

    useEffect(() => {
        if (timer === 0) {
            setPaciResponse("failed");
            setTimer(null);
        }
        if (pending && timer % 15 === 0 && timer < 300 && timer > 0) {
            checkPaciConnection();
        }
    }, [timer]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (paciResponse === "failed") {
            clearTimer();
        }
    }, [paciResponse])

    const fetchTimerValue = () => {
        let business = JSON.parse(Storage.get("business", true)) || {};
        if (business["paci_timer_seconds"] || business["paci_timer_seconds"] === 0) {
            setTimer(business["paci_timer_seconds"]);
            setBusinessTime(business["paci_timer_seconds"]);
        }
    }

    const checkPaciConnection = () => {
        setPending(false);
        setPaciResponse(null);
        PaciService.status()
            .then(response => {
                if (response && response?.data && response?.data?.Status && response?.data?.Status === 3) {
                    clearTimer();
                    User.updateFlowStatus("selfie_submitted", true)
                    setPaciResponse("success");

                } else if (response && response?.data && response?.data?.Status && response?.data?.Status === 2) {
                    clearTimer();
                    setPaciResponse("failed")
                } else {
                    // User.fetchFlowStatus();
                    setPending(true);
                }
            })
            .catch(error => {
                clearTimer();
                console.error('paci check catch issue:', error);
            })
    }

    return (
        <>
            {paciResponse === null ?
                <div className="storefront-two-col-pg">
                    <div className="paci">
                        <StorefrontTitle
                            title={translationKeys["ob_conecting_to_PACI"]}
                            desc={"Please wait while we connect you to PACI Verification process"}
                        />
                        <img src={PACIMob} alt="Connecting to PACI..." />
                        <div className="paci-progress">
                            <div style={{ width: `${(timer / businessTime) * 100}%` }}>
                                &nbsp;
                            </div>
                        </div>
                        <div className="paci-timer">{getTime()}</div>
                        <span>{translationKeys["ob_connection_connecting"]}</span>
                    </div>
                    <StmSummary />
                </div> :
                null
            }
            {paciResponse === "success" ? <PaciSuccess history={props.history} /> : null}
            {paciResponse === "failed" ? <PaciFailure
                setPaciResponse={setPaciResponse}
                fetchTimerValue={fetchTimerValue}
                checkPaciConnection={checkPaciConnection}
                history={props.history}
                updateTimer={updateTimer} /> : null}
        </>
    )
}

export default PaciConnection;